import { createReducer, on } from '@ngrx/store'
import { httpErrorInterceptorActions } from '../actions/error.actions'


export const initialState = { statusCode: 0 }

export const httpErrorInterceptorReducer = createReducer(
    initialState,
    on(httpErrorInterceptorActions, ((state, { httpErrorInterceptor }) => {
        return { ...state, statusCode: httpErrorInterceptor.statusCode }
    }))
)